// ============================================================================
// avecClassificacao: espelho no cliente da lista de relatórios AGREGADOS do
// proxy (api/avec.js, AGGREGATE_REPORTS). Um teste garante que os dois são
// iguais (tests/dash-flags-reversao.test.mjs).
// ============================================================================
// Agregado = vai para a CDN de 30 s do proxy, então não precisa de fila no
// aparelho. Todo o resto (pessoal, financeiro, desconhecido) é "sem CDN": cada
// chamada chega ao Avec. Fail closed: código fora da lista conta como sem CDN.
// ATENÇÃO: se um dia ligarem AVEC_AGREGADO_MODO=sessao (ou AVEC_PESSOAIS_MODO=
// aberto) na Vercel, este espelho fica errado: os agregados passam a ir ao
// Avec sem CDN e também precisariam entrar na fila.
// ============================================================================

export const AVEC_AGREGADOS_CDN = new Set([
  '0021', '0032', '0033', '0041', '0088',
  '0126', '0153', '0154', '0156', '0157',
  '0281', '0326', '0348', 'X126', 'X226',
]);

export function chaveRelatorioCliente(code) {
  const r = String(code ?? '');
  return /^\d+$/.test(r) ? r.padStart(4, '0') : r;
}

export function ehPessoalSemCdn(code) {
  return !AVEC_AGREGADOS_CDN.has(chaveRelatorioCliente(code));
}
